import React, { useState, useEffect, useRef } from 'react'
import { useIntl } from 'react-intl'
import Button from 'react-bootstrap/Button';
import axios, { AxiosResponse } from 'axios'
import swal from 'sweetalert2'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../auth/core/Auth'
import { useLang } from '../../../../_metronic/i18n/Metronici18n';
import { CustomGetExamType } from '../../../pages/examtype/list/core/_requests';
import { createCustomOtherResult } from '../../../pages/otherresult/list/core/_requests';
import { ApproveOtherResultTransaction } from '../../../pages/applicationuser/list/core/_requests';
import CustomSelect from '../../custom-select/CustomSelect';




export function OtherExams() {

    const { logout, currentUser, setCurrentUser } = useAuth();
    const intl = useIntl();
    const navigate = useNavigate();
    const [logoutt, setLogout] = useState(false);
    const lang = useLang()
    const [file, setFile] = useState(null);
    const [rerenderKey, setRerenderKey] = useState(1);
    const [fileError, setFileError] = useState("");
    const [examTypes, setExamTypes] = useState([]);
    
    const [examTypes2, setExamTypes2] = React.useState<any[]>([
        { value: null, label: "Seçiniz" },
    ]);
    const [disabled, setdisabled] = useState(false);
    const [payload, setPayload]: any = useState([{
        name: '-',
        applicationUserId: currentUser?.id,
        examTypeId: null,
        file: null,
        docTypeType: null,
        docTypeName: null,
        point: null,
        gradingSystem: null,
        gradingSystemEn: null,
        MaxNot: null,
        MinNot: null

    }]);





    useEffect(() => {
        if (logoutt) {
            logout()
        } else if (currentUser?.trYosTransactionDone === "0") {
            navigate('/exam/tryos');
        } else if (currentUser?.idUploaded !== "1") {
            navigate('/exam/uploadid');
        } else if (currentUser?.otherResultTransactionDone === "1") {
            navigate('/exam/uploadconfirmation');
        }
    }, [logoutt])

    useEffect(() => {
        CustomGetExamType().then((res: any) => {
            
            setExamTypes(res)
            setExamTypes2([
                // { value: "null", label: "aa" },
                ...res.map((a: any) => ({ value: a?.id, label: a?.name })),
            ]);
        })
    }, [])


    const handleLogout = async () => {
        setLogout(true)
    }





    const handleFileChange = (e: any, index: number) => {


        // const selected = e.target.files[0];
        const ALLOWED_TYPES = ["application/pdf", "image/jpeg", "image/png"];


        if (e && ALLOWED_TYPES.includes(e.type)) {


            setPayload((prevPayload: any) => {

                return prevPayload.map((item: any, i: any) => {
                    if (i === index) {
                        // Eğer indeks mevcutsa, sadece adını değiştir ve diğer özellikleri kopyala
                        return {
                            ...item,

                            file: e,

                        };
                    } else {
                        // Diğer durumlarda objeyi olduğu gibi kopyala
                        return item;
                    }
                });
            });
        } else {
            setFileError("Lütfen geçerli bir dosya türü seçin (.pdf, .jpg veya .png)");
        }
    };


    const SelectOtherExam = (e: any, index: number) => {
        const selected: any = (examTypes.find((item: any) => item.id == e))
        setPayload((prevPayload: any) => {
            // İndeks dışında diğer objeleri olduğu gibi kopyala
            return prevPayload.map((item: any, i: any) => {
                if (i === index) {
                    // Eğer indeks mevcutsa, sadece adını değiştir ve diğer özellikleri kopyala
                    return {
                        ...item,

                        examTypeId: e,
                        docTypeType: selected?.docType?.type,
                        docTypeName: selected?.docType?.name,
                        gradingSystem: selected?.diplomaAvarageType?.name,
                        gradingSystemEn: selected?.diplomaAvarageType?.nameEn,
                        MaxNot: selected?.diplomaAvarageType?.maxPoints,
                        MinNot: selected?.diplomaAvarageType?.minPoints

                    };
                } else {
                    // Diğer durumlarda objeyi olduğu gibi kopyala
                    return item;
                }
            });
        });

    };

    const HandlePoint = (e: any, index: number) => {


        setPayload((prevPayload: any) => {
            // İndeks dışında diğer objeleri olduğu gibi kopyala
            return prevPayload.map((item: any, i: any) => {
                if (i === index) {
                    // Eğer indeks mevcutsa, sadece adını değiştir ve diğer özellikleri kopyala
                    return {
                        ...item,
                        point: e,

                    };
                } else {
                    // Diğer durumlarda objeyi olduğu gibi kopyala
                    return item;
                }
            });
        });


    }



    const SaveOtherResults = async () => {


        swal.fire({
            title: intl.formatMessage({
                id: 'Swal_Eminmisin_Uyari'
            }),
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: intl.formatMessage({ id: 'Yes' }),
            cancelButtonText: intl.formatMessage({ id: 'No' }),

        }).then(async (result) => {
            if (result.isConfirmed) {
                let WithoutPoint: any = [];
                let WithPoint: any = [];

                // payload dizisini dön ve docTypeName değerine göre ayrıştır
                payload?.forEach((item: any) => {
                    if (item.docTypeName === "Diğer" || item.docTypeName === null) {
                        WithoutPoint.push(item);
                    } else {
                        WithPoint.push(item);
                    }
                });
            

                const IsWithPointValid = WithPoint?.some((item: any) => item.point === null || item.point === undefined || item.point === '' || item.examTypeId === null || item.examTypeId === undefined || item.examTypeId === '' || item.file === undefined || item.file === null)
                const IsWithoutPointValid = WithoutPoint?.some((item: any) => item.examTypeId === null || item.examTypeId === '' || item.file === undefined || item.file === null)

                // const IsPointsTrue = WithPoint.some((item: any) => parseFloat(item.point) > item?.MaxNot || parseFloat(item.point) < item?.MinNot)

              


                if (IsWithPointValid || IsWithoutPointValid) {

                    swal.fire({
                        title: intl.formatMessage({
                            id: 'Swal_Eksik'
                        }),
                        // text: intl.formatMessage({ id: 'Error_Massage' }),
                        icon: 'error',
                        confirmButtonText: intl.formatMessage({ id: 'Okay' })
                    })

                } else {
                   
                   
                    const IsPointsTrue = WithPoint?.some((item: any) => {
                        const point = parseFloat(item?.point.replace(",", "."));
                       
                        return point > item?.MaxNot || point < item?.MinNot || point == null;
                    });

                    if (IsPointsTrue) {

                        swal.fire({
                            title: intl.formatMessage({
                                id: 'Swal_NotSitemi'
                            }),
                            // text: intl.formatMessage({ id: 'Error_Massage' }),
                            icon: 'error',
                            confirmButtonText: intl.formatMessage({ id: 'Okay' })
                        })

                    } else {
                        let newPayload: any = [];

                        // payload dizisini dön ve istenen alanları yeni dizide topla
                        setdisabled(true)
                        payload.forEach((item: any) => {
                            if (item.docTypeName === "Diğer") {
                                const newItem = {
                                    name: item.name,
                                    applicationUserId: item.applicationUserId,
                                    file: item.file,
                                    examTypeId: item.examTypeId
                                };
                                newPayload.push(newItem);
                            } else {
                                const newItem = {
                                    name: item.name,
                                    applicationUserId: item.applicationUserId,
                                    point: item.point,
                                    file: item.file,
                                    examTypeId: item.examTypeId
                                };
                                newPayload.push(newItem);
                            }

                        });

                        swal.fire({
                            title: intl.formatMessage({
                                id: 'Swal_proces'
                            }),
                            text: intl.formatMessage({ id: 'Swall_wait' }),
                            icon: 'info',
                            showConfirmButton: false,
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        })
                        newPayload.map(async (item: any) => {
                            await createCustomOtherResult(item)
                        })
                        await ApproveOtherResultTransaction()
                        await updateOtherResultTransactionDone("1");
                         navigate('/exam/uploadconfirmation');
                        swal.close();
                        setdisabled(false)
                    }




                }


            } else {
                swal.close(); // Modal'ı kapatmak için bu satırı ekleyin
            }
        });








    }


    const updateOtherResultTransactionDone = async (newValue: string) => {
        return new Promise<void>((resolve, reject) => {
            if (currentUser?.id === undefined) {
                reject("User ID is undefined.");
                return;
            }

            const updatedUser = {
                ...currentUser,
                otherResultTransactionDone: newValue,

            };

            setCurrentUser(updatedUser);
            resolve();
        });
    };

    const NextPage = () => {

        swal.fire({
            title: intl.formatMessage({
                id: 'Swal_Devam'
            }),
            // text: intl.formatMessage({ id: 'TRYOS_VARMI' }),
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: intl.formatMessage({ id: 'Yes' }),
            cancelButtonText: intl.formatMessage({ id: 'No' })
        }).then(async (result) => {
            if (result.isConfirmed) {
                setdisabled(true)
                swal.fire({
                    title: intl.formatMessage({
                        id: 'Swal_proces'
                    }),
                    text: intl.formatMessage({ id: 'Swall_wait' }),
                    icon: 'info',
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    allowEscapeKey: false
                })
                await ApproveOtherResultTransaction()
                await updateOtherResultTransactionDone("1");
                navigate('/exam/uploadconfirmation');
                swal.close();
                setdisabled(false)
            } else {
                swal.close(); // Modal'ı kapatmak için bu satırı ekleyin
            }
        });

    }

    const AddDocument = () => {
        setPayload((prevPayload: any) => [
            ...prevPayload,
            {
                name: '-',
                applicationUserId: currentUser?.id,
                examTypeId: null,
                file: null
            }
        ]);
    }



    const RemoveDocument = () => {
        if (payload?.length > 1) {
            const newArray = [...payload]; // payload dizisini bir kopyasını oluştur
            newArray.pop(); // Son öğeyi kaldırır

            // Son öğe kaldırılmış yeni diziyi kullanmak için setPayload'i kullanabiliriz
            setPayload(newArray);
        }


    }
    


    function handleSelectExam(data: any, index: number) {
       

        SelectOtherExam(data.value, index)
    }
    
   

    return (
        <>
            <div className='row fv-row mt-7 justify-content-end p-10 ' >
                <div className="alert alert-warning text-black fw-bold mt-5 ">{intl.formatMessage({ id: 'OtherExamsDesc' })}</div>
                <div className='d-flex w-100  flex-column   ' >

                    {payload && payload.map((item: any, index: number) => {

                        return (
                            <div className='d-flex w-100  flex-column pb-7 mb-2  ' style={{ borderBottom: '1px dashed  black' }}>
                                <div className='col-lg-12 fv-row mt-7  '>
                                    <p><strong>{intl.formatMessage({ id: 'Select_Exam' })}</strong></p>
                                    {/* <select
                                        className='form-select form-select-solid form-select-lg'
                                        value={item?.examTypeId}
                                        onChange={(e: any) => SelectOtherExam(e.target.value, index)}
                                    >
                                        <option value=''>{intl.formatMessage({ id: 'SEÇİNİZ' })}</option>
                                        {examTypes.map((myval: any) => (
                                            <option value={myval?.id} key={myval?.id as any}>
                                                {myval?.name}
                                            </option>
                                        ))}
                                    </select> */}

                                    <CustomSelect
                            options={examTypes2}
                            onChange={(data: any) => handleSelectExam(data, index)}
                            // value={applicationUserid}
                            isSearchable={true}
                            isMulti={false}
                        />

                                </div>
                                {/* item?.docTypeType !== null && item?.docTypeName !== null && item?.docTypeType !== "belgeturu" && */}
                                {item.docTypeName !== null && item.docTypeName !== undefined && item.docTypeName !== "Diğer" ?
                                    <div className='col-xl-12 mt-10'>
                                        <div className='fv-row mb-5' >
                                            <label className='form-label fw-bolder text-dark fs-6'>{intl.formatMessage({ id: 'Sınav/Program Puanı' })}</label>
                                            <br></br>

                                            {lang === "tr" ? <label className='form-label  fs-6'>({item?.gradingSystem})</label>
                                                : <label className='form-label  fs-6'>({item?.gradingSystemEn})</label>}


                                            <input
                                                placeholder={intl.formatMessage({ id: 'exp : 80,45' })}
                                                type="text"
                                                value={item?.point}
                                                onKeyDown={(e: any) => {
                                                    if (e.key === '.' && e.target.value.indexOf(',') === -1) { // Nokta tuşuna basıldığında ve virgül yoksa
                                                        e.preventDefault(); // Noktanın varsayılan davranışını engelle
                                                        const cursorPosition = e.target.selectionStart; // İmlecin konumunu al
                                                        e.target.value = e.target.value.substring(0, cursorPosition) + ',' + e.target.value.substring(cursorPosition); // Noktayı imlecin bulunduğu konuma virgül olarak ekle
                                                        e.target.setSelectionRange(cursorPosition + 1, cursorPosition + 1); // İmleci virgülün sağ tarafına konumlandır
                                                    } else if (e.key === ',' && e.target.value.split(',').length > 1) { // Virgül tuşuna basıldığında ve virgül zaten varsa
                                                        e.preventDefault(); // Virgülün varsayılan davranışını engelle
                                                    }
                                                }}
                                                onInput={(e: any) => {
                                                    e.target.value = e.target.value.replace(/[^0-9,]/g, ''); // Sadece rakamlar ve virgül kabul edilir
                                                }}
                                                onChange={(e) => HandlePoint(e.target.value, index)}
                                                className='form-control form-control-lg form-control-solid'
                                            />
                                        </div>
                                    </div>
                                    : <> </>}




                                <div className="row mt-5 p-3">
                                    <div className="col-12">
                                        <p><strong>{intl.formatMessage({ id: 'UploadDocument' })}</strong></p>
                                        <input type="file" onChange={(e: any) => handleFileChange(e.target.files[0], index)} accept=".pdf, image/jpeg, image/png" />
                                        {/* <input type="file" onChange={handleFileChange2} accept=".pdf, image/jpeg, image/png" /> */}
                                        {fileError && <p style={{ color: "red" }}>{fileError}</p>}
                                    </div>
                                </div>
                            </div>
                        )
                    })}


                    <div className='d-flex  mt-5 mb-md-5 justify-content-center gap-3 flex-sm-row flex-column '>

                        <div className=' d-flex  justify-content-start'>
                            <Button variant='primary' onClick={RemoveDocument} disabled={disabled}>
                                {intl.formatMessage({ id: 'Remove' })} -
                            </Button>
                        </div>
                        <div className=' d-flex  justify-content-start'>
                            <Button variant='primary' onClick={AddDocument} disabled={disabled}>
                                {intl.formatMessage({ id: 'Add' })} +
                            </Button>
                        </div>

                    </div>


                    <div className='d-flex  mt-5 mb-md-5 justify-content-center gap-3 flex-sm-row flex-column '>

                        <div className=' d-flex   justify-content-start'>
                            <Button variant='primary' onClick={SaveOtherResults} disabled={disabled}>
                                {intl.formatMessage({ id: 'MODALFORM.SAVE' })}
                            </Button>
                        </div>
                        <div className=' d-flex  justify-content-start'>
                            <Button variant='primary' onClick={NextPage} disabled={disabled}>
                                {intl.formatMessage({ id: 'IslemYapmadanDevamEt' })}
                            </Button>
                        </div>
                        <div className=' d-flex  justify-content-start'>
                            <Button variant='danger' onClick={handleLogout} disabled={disabled}>
                                {intl.formatMessage({ id: 'Logout' })}
                            </Button>
                        </div>
                    </div>

                </div>




            </div>
        </>
    )
}
